module.exports = __webpack_public_path__ + "static/media/mood-depressed.59868dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mood-depressed.svg
// module id = 527
// module chunks = 31